var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogomarkUnicolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.9027 39.7301C94.9027 53.8649 87.5382 66.2787 76.441 73.3334C78.3981 68.6303 79.4777 63.4698 79.4777 58.0578C79.4777 41.5618 69.4492 27.4126 55.1638 21.3845C50.4213 19.3819 45.2087 18.2759 39.7388 18.2759C31.9115 18.2759 24.6132 20.5408 18.4617 24.4545C7.70589 31.2914 0.456823 43.1636 0.021639 56.758C0.007213 56.249 0 55.7375 0 55.2236C0 26.0202 22.644 2.11089 51.3145 0.133585C52.5864 0.0445284 53.8691 0 55.1638 0C56.4586 0 57.7413 0.0445284 59.012 0.133585C73.8792 1.5621 86.354 11.1947 91.866 24.4545C93.8231 29.1577 94.9027 34.3181 94.9027 39.7301Z",
    fill: "url(#paint0_radial_61_482)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.001 55.1305C110.001 55.6448 109.994 56.1566 109.979 56.6661C109.822 62.4614 108.777 68.034 106.975 73.2512C101.012 87.6529 86.8734 97.7779 70.3822 97.7779C64.929 97.7779 59.7336 96.6711 55.0055 94.6671C45.4368 90.6144 37.7832 82.8921 33.791 73.2536C39.9237 77.169 47.2009 79.4368 55.0055 79.4368C62.8101 79.4368 70.085 77.1702 76.2176 73.2536C87.2809 66.1937 94.6229 53.7708 94.6229 39.6257C94.6229 34.2097 93.5466 29.0454 91.5955 24.3388C86.1004 11.0692 73.6637 1.42957 58.8419 0C87.4247 1.97875 110.001 25.9045 110.001 55.1305Z",
    fill: "url(#paint1_radial_61_482)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.125 72.9422C99.6493 94.5141 79.1645 110 55.0674 110C30.9702 110 10.4855 94.5141 3.00974 72.9422C1.20414 67.737 0.15727 62.1773 0 56.3953C0.434594 42.8223 7.67383 30.9688 18.415 24.1426C24.5582 20.2351 31.8466 17.9738 39.6633 17.9738C45.1257 17.9738 50.3313 19.078 55.0674 21.0774C40.8002 27.0949 30.7853 41.223 30.7853 57.693C30.7853 63.0965 31.8634 68.2489 33.8167 72.9446C37.8157 82.5608 45.4823 90.2653 55.0674 94.3086C59.8035 96.3081 65.0078 97.4123 70.4702 97.4123C86.9896 97.4123 101.152 87.3107 107.125 72.9422Z",
    fill: "url(#paint2_radial_61_482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_61_482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-68.7624 9.14776 -11.8384 -89.1802 59.3961 24.9277)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37392E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37392E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_61_482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-43.7277 44.6281 -34.7839 -34.4163 83.9294 62.4541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37392E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37392E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_61_482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-57.9467 -23.2901 27.1113 -67.5709 32.1454 71.1952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37392E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37392E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomarkUnicolor);
export default __webpack_public_path__ + "static/media/LOGO MARK - UNICOLOR.ed1e273220d8e7ff7364cef0a1f13152.svg";
export { ForwardRef as ReactComponent };